import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import InputMask from "react-input-mask";

import CadastroObservacao from "./CadastroObservacao";
import StringUtil from "../../actions/string.js";
import UI from "../../actions/ui-helper";
import API from "../../actions/api-helper";
import DataUtil from "../../actions/data.js";
import Currency from "../main/utils/masks/Currency";
import {
  formatPointCurrency,
  formatMoneyToEditRequest,
} from "../main/utils/utils";

class CadastroCategoria extends Component {
  constructor(props) {
    super(props);
    this.state = {
      financeiro: this.getInitialState(),
      pronto: true,
    };
    if (this.props.match.params.id) {
      this.state.financeiro.id = this.props.match.params.id;
      this.state.pronto = false;
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChecked = this.handleChecked.bind(this);
    this.handleChangeValor = this.handleChangeValor.bind(this);
  }

  getInitialState() {
    return {
      id: 0,
      origem: "RECEITA",
      data: DataUtil.hoje(),
      valor: Currency.conformToMask(0.0),
      pago: "N",
    };
  }

  componentDidUpdate() {
    UI.inputHelpers();
  }

  componentDidMount() {
    UI.inputHelpers();
    this.initialize();

    // Verifica se vem de uma rota com id
    let id = parseInt(this.state.financeiro.id);
    if (id !== 0) {
      UI.loader("show", "Um momento...");
      API.get("/financeiro/" + this.state.financeiro.id)
        .then(
          function (json) {
            this.setState({
              financeiro: {
                ...json,
                valor: formatPointCurrency(json.valor),
                data: DataUtil.dateISOToDateMasked(json.data),
              },
              pronto: true,
            });

            UI.loader("hide");
          }.bind(this)
        )
        .catch(function (json) {
          UI.alert(false, json.message);
          UI.loader("hide");
        });
    }
  }

  handleChange(event) {
    let financeiro = this.state.financeiro;
    let name = event.target.name;
    financeiro[event.target.name] = event.target.value;

    (financeiro[name].length === 0 || financeiro[name] === "NENHUMA") &&
      delete financeiro[name];
    this.setState({ financeiro: financeiro });
  }

  handleChecked(event) {
    let financeiro = this.state.financeiro;
    financeiro[event.target.name] = event.target.checked;
    this.setState({ financeiro: financeiro });
  }

  handleChangeValor(event) {
    let financeiro = this.state.financeiro;
    let name = event.target.name;
    financeiro[name] = event.target.value;

    financeiro[name] = formatMoneyToEditRequest(financeiro[name]);

    this.setState({ financeiro });
  }

  handleSubmit(event) {
    event.preventDefault();

    // Validação dos campos (temporario)
    let data = this.state.financeiro;
    // if (data.descricao.length < 3) {
    //   UI.alert(false, "Descrição é obrigatório.");
    //   return;
    // }

    data.id === 0 && delete data.id;
    data.valor = formatMoneyToEditRequest(data.valor);

    console.log(this.state.financeiro.categoria);
    this.state.financeiro.categoria &&
      data.categoriaId === null &&
      this.setState({
        data: { categoriaId: this.state.financeiro.categoria.id },
      });

    UI.loader("show", "Um momento...");
    API.post("/financeiro", data)
      .then(
        function (json) {
          this.setState({ financeiro: json.data });
          UI.alert(true, "Lançamento realizado.");
          UI.loader("hide");
          this.props.history.push("/financeiro/consulta");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  initialize = async () => {
    this.fetchCategoria();
    this.fetchFormaPagamento();
  };

  fetchCategoria = async () => {
    UI.loader("show", "Um momento...");
    await API.get("/categoria")
      .then((categorias) => {
        this.setState({ categorias });
        UI.loader("hide");
      })
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  };

  fetchFormaPagamento = async () => {
    UI.loader("show", "Um momento...");
    await API.get("/forma-pagamento")
      .then((formaPagamentos) => {
        this.setState({ formaPagamentos });
        UI.loader("hide");
      })
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  };

  renderOption = (option) => {
    return Array.isArray(option) && option.length
      ? option.map((op, i) => {
          if (i === 0) {
            return (
              <>
                <option value="NENHUMA">NENHUMA</option>
                <option value={op.id}>{op.descricao}</option>
              </>
            );
          } else {
            return <option value={op.id}>{op.descricao}</option>;
          }
        })
      : [];
  };

  render() {
    const { formaPagamentos, categorias } = this.state;

    if (!this.state.pronto) return false;
    this.tableId = StringUtil.uuid(5);
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="form-group row">
                  <div className="col-md-11">
                    {this.state.financeiro.id === 0 && (
                      <h4 className="card-title">CADASTRO LANÇAMENTO</h4>
                    )}
                    {this.state.financeiro.id !== 0 && (
                      <h4 className="card-title">
                        CADASTRO FINANCEIRO #{this.state.financeiro.id}
                      </h4>
                    )}
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Origem *</label>
                    <select
                      name="origem"
                      className="form-control"
                      value={this.state.financeiro.origem}
                      onChange={this.handleChange}
                    >
                      <option value="RECEITAS">ENTRADA</option>
                      <option value="RECEITAS">RECEITAS</option>
                      <option value="DESPESAS">DESPESAS</option>
                      <option value="TRANSFERENCIA">TRANSFERÊNCIA</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>Data *</label>
                    <InputMask
                      placeholder="DATA"
                      name="data"
                      className="form-control"
                      mask="99/99/9999"
                      value={this.state.financeiro.data}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Descrição</label>
                    <input
                      placeholder="DESCRIÇÃO"
                      autoFocus
                      name="descricao"
                      type="text"
                      maxLength="254"
                      className="form-control"
                      value={this.state.financeiro.descricao}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label>Documento Nota Fiscal</label>
                    <input
                      autoFocus
                      placeholder="NOTA FISCAL"
                      name="notaFiscal"
                      type="text"
                      maxLength="254"
                      className="form-control"
                      value={this.state.financeiro.notaFiscal}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Recebido de:</label>
                    <input
                      placeholder="RECEBIDO DE: "
                      autoFocus
                      name="pagoDe"
                      type="text"
                      maxLength="254"
                      className="form-control"
                      value={this.state.financeiro.pagoDe}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label>Forma de Pagamento</label>
                    <select
                      name="formaPagamentoId"
                      className="form-control"
                      value={this.state.financeiro.formaPagamentoId}
                      onChange={this.handleChange}
                    >
                      {this.renderOption(formaPagamentos)}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>Valor</label>
                    <input
                      placeholder="VALOR"
                      autoFocus
                      name="valor"
                      type="text"
                      maxLength="11"
                      className="form-control"
                      value={Currency.conformToMask(
                        this.state.financeiro.valor
                      )}
                      onChange={this.handleChangeValor}
                    />
                  </div>
                  <div className="col-sm-3">
                    <label>Categoria</label>
                    <select
                      name="categoriaId"
                      className="form-control"
                      value={this.state.financeiro.categoriaId}
                      onChange={this.handleChange}
                    >
                      {this.renderOption(categorias)}
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-3">
                    <label>Situação</label>
                    <select
                      name="situacao"
                      className="form-control"
                      value={this.state.financeiro.situacao}
                      onChange={this.handleChange}
                    >
                      <option value="NENHUMA">NENHUMA</option>
                      <option value="VENCIDO">VENCIDO</option>
                      <option value="AVENCER">A VENCER</option>
                      <option value="VENCENDONODIA">VENCENDO NO DIA</option>
                      <option value="PAGO">PAGO</option>
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label>Periodicidade</label>
                    <select
                      name="periodicidade"
                      className="form-control"
                      value={this.state.financeiro.periodicidade}
                      onChange={this.handleChange}
                    >
                      <option value="NENHUMA">NENHUMA</option>
                      <option value="AVISTA">À VISTA</option>
                      <option value="PARCELADO">PARCELADO</option>
                      <option value="RECORRENTE">RECORRENTE</option>
                      <option value="SEMANAL">SEMANAL</option>
                      <option value="QUINZENAL">QUINZENAL</option>
                      <option value="BIMESTRAL">BIMESTRAL</option>
                      <option value="TRIMESTRAL">TRIMESTRAL</option>
                      <option value="SEMESTRAL">SEMESTRAL</option>
                      <option value="ANUAL">ANUAL</option>
                    </select>
                  </div>
                  <div className="col-sm-3">
                    <label>Tipo</label>
                    <select
                      name="tipo"
                      className="form-control"
                      value={this.state.financeiro.tipo}
                      onChange={this.handleChange}
                    >
                      <option value="NENHUMA">NENHUMA</option>
                      <option value="FIXA">FIXA</option>
                      <option value="VARIAVEL">VARIÁVEL</option>
                      <option value="PESSOAS">PESSOAS</option>
                      <option value="IMPOSTOS">IMPOSTOS</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>Pago *</label>
                    <select
                      name="pago"
                      className="form-control"
                      value={this.state.financeiro.pago}
                      onChange={this.handleChange}
                    >
                      <option value="S">SIM</option>
                      <option value="N">NÃO</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CadastroObservacao
          observacao={this.state.financeiro.observacao}
          onChange={this.handleChange}
        />
      </form>
    );
  }
}

export default withRouter(CadastroCategoria);
